import css from 'styled-jsx/css';

export default css`
  .CerosEmbed {
    margin: 1em;
  }
`;
